<svg xmlns="http://www.w3.org/2000/svg" width="44.595" height="44.594" viewBox="0 0 44.595 44.594">
    <path id="Pfad_98" data-name="Pfad 98" d="M-3.933-1.449V-13.524h-11.73v-7.8h11.73V-33.189h7.8v11.868h11.8v7.8H3.864V-1.449Z" transform="translate(10.051 34.544) rotate(45)" fill="#fff"/>
  </svg>
  